export default function LoadingSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="36px"
      viewBox="0 0 24 24"
      width="36px"
      fill="#000000"
      className="animate-spin 5s infinite"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
        className="fill-gray-800 group-hover:fill-gray-600 dark:fill-slate-300 dark:group-hover:fill-slate-400"
      />
    </svg>
  )
}
